import { inject, Injectable } from '@angular/core';
import { UserStateService } from 'src/app/auth/services/user-state.service';

@Injectable({
  providedIn: 'root',
})
export class BrandSettingsService {
  private userStateService = inject(UserStateService);

  /**
   * Brand Settings Centralization is released incrementally. Until it ships,
   * it is only available outside production, or to `sa` users in production
   * so it can be validated there before release.
   */
  isReleased(): boolean {
    return (
      this.userStateService.hasPermission('!PROD') ||
      this.userStateService.hasRole('sa')
    );
  }
}
